
<p-table #myTab [value]="auditLog.entries" [rows]="maxEntries" [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resizableColumns]="true">
  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn>Time Stamp</th>
      <th pResizableColumn>Type</th>
      <th pResizableColumn>User</th>
      <th pResizableColumn>Description</th>
      @if (isNetworkChangeLog) {
        <th pResizableColumn>Device Name</th>
      }
      @if (isNetworkChangeLog) {
        <th pResizableColumn>Device IP Address</th>
      }
      @if (isNetworkChangeLog) {
        <th pResizableColumn>Device Mac Address</th>
      }
      @if (isNetworkChangeLog) {
        <th pResizableColumn>Interface Index</th>
      }
      @if (isNetworkChangeLog) {
        <th pResizableColumn>Interface Name</th>
      }
    </tr>
    <tr class="uv-table-filter">
      <th></th>
      <th>
        <select class="form-control" (change)="filterUpdated('EventType', $event.target.value)">
          <option value=""></option>
          <option value="AdminAction">Admin Action</option>
          <option value="Login">Login</option>
          <option value="Logout">Logout</option>
          <option value="PasswordChange">Password Change</option>
          <option value="NetworkChange">Network Change</option>
        </select>
      </th>
      <th>
        <input pInputText type="text" style="width: 100%;" (input)="filterUpdated('User', $event.target.value)"/>
      </th>
      <th>
        <input pInputText type="text" style="width: 100%;" (input)="filterUpdated('Description', $event.target.value)"/>
      </th>
      @if (isNetworkChangeLog) {
        <th>
          <input pInputText type="text" style="width: 100%;" (input)="filterUpdated('DeviceName', $event.target.value)"/>
        </th>
      }
      @if (isNetworkChangeLog) {
        <th>
          <input pInputText type="text" style="width: 100%;" (input)="filterUpdated('IpAddress', $event.target.value)"/>
        </th>
      }
      @if (isNetworkChangeLog) {
        <th>
          <input pInputText type="text" style="width: 100%;" (input)="filterUpdated('MacAddress', $event.target.value)"/>
        </th>
      }
      @if (isNetworkChangeLog) {
        <th>
          <input pInputText type="text" style="width: 100%;" (input)="filterUpdated('IfIndex', $event.target.value)"/>
        </th>
      }
      @if (isNetworkChangeLog) {
        <th>
          <input pInputText type="text" style="width: 100%;" (input)="filterUpdated('IfName', $event.target.value)"/>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-entry>
    <tr>
      <td>
        {{ entry.audit_log_entry.audit_log_timestamp }}
      </td>
      <td>
        {{ entry.audit_log_entry.audit_log_event_type }}
      </td>
      <td>
        {{ entry.audit_log_entry.audit_log_user }}
      </td>
      <td>
        {{ entry.audit_log_entry.audit_log_description}}
      </td>
      @if (isNetworkChangeLog) {
        <td>
          {{ entry.audit_log_entry.network_change_details.device_name }}
        </td>
      }
      @if (isNetworkChangeLog) {
        <td>
          {{ entry.audit_log_entry.network_change_details.ip_address }}
        </td>
      }
      @if (isNetworkChangeLog) {
        <td>
          {{ entry.audit_log_entry.network_change_details.mac_address }}
        </td>
      }
      @if (isNetworkChangeLog) {
        <td>
          {{ entry.audit_log_entry.network_change_details.if_index }}
        </td>
      }
      @if (isNetworkChangeLog) {
        <td>
          {{ entry.audit_log_entry.network_change_details.if_name }}
        </td>
      }
    </tr>
  </ng-template>
</p-table>

<p-paginator [rows]="maxEntries" [totalRecords]="auditLog.totalCount" (onPageChange)="paginate($event)"></p-paginator>

<div style="text-align: center; margin-top: 5px;">
  <button type="button" pButton icon="fa fa-refresh" (click)="updateEvents()" [disabled]="false"
  label="Refresh" title="Refresh events"></button>
</div>
